module.exports = __webpack_public_path__ + "static/Group 6667-1d0e3c903d97e1fe6897ad51539b0655.png";